import React from 'react';
import {
  makeStyles,
  shorthands,
  Text,
  Card,
  CardHeader,
  Title3,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    ...shorthands.padding('20px'),
  },
  card: {
    maxWidth: '800px',
    width: '100%',
  },
  content: {
    ...shorthands.padding('20px'),
  },
  section: {
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '10px',
    color: '#323130',
  },
  description: {
    color: '#605e5c',
    lineHeight: '1.6',
  },
});

function AnnouncementPage() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardHeader
          header={<Title3>Announcement Management</Title3>}
          description="Create and manage system announcements"
        />
        <div className={classes.content}>
          <div className={classes.section}>
            <Text className={classes.sectionTitle}>Announcement Features</Text>
            <Text className={classes.description}>
              On this page, you can create, edit, and manage system-wide announcements. Announcements are displayed to all users to communicate important information, system maintenance notifications, or other critical updates.
            </Text>
          </div>
          
          <div className={classes.section}>
            <Text className={classes.sectionTitle}>Key Features</Text>
            <Text className={classes.description}>
              • Create new announcements<br/>
              • Edit existing announcements<br/>
              • Set announcement priority<br/>
              • Schedule announcement release time<br/>
              • View announcement statistics
            </Text>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default AnnouncementPage;